import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import type { AiChatResponse } from '../types/aiChat.types';

type AskParams = {
  spaceId: string;
  /** Absent for the first question: the edge function then creates the conversation. */
  conversationId?: string;
  question: string;
};

const DEFAULT_ERROR = "L'assistant n'a pas pu répondre. Réessayez dans un instant.";

async function readErrorMessage(error: { message: string }): Promise<string> {
  // Supabase FunctionsHttpError stores the raw Response in error.context
  const errorWithContext = error as unknown as { context?: unknown };
  if (errorWithContext.context instanceof Response) {
    try {
      const body = (await errorWithContext.context.clone().json()) as { message?: string };
      if (body?.message) {
        return body.message;
      }
    } catch {
      // Fallback to the default message if json parsing fails
    }
  }
  return DEFAULT_ERROR;
}

async function askAssistant(params: AskParams): Promise<AiChatResponse> {
  const { data, error } = await apiClient.functions.invoke('ai-chat', {
    body: { spaceId: params.spaceId, conversationId: params.conversationId, question: params.question },
  });

  if (error) {
    throw new Error(await readErrorMessage(error));
  }

  return data as AiChatResponse;
}

export function useAskAssistant() {
  return useMutation({
    mutationFn: askAssistant,
  });
}
